import IconButton from "@mui/material/IconButton";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";


interface IProps {
    page: string;
    label?: string;
}

export default function HelpLink(props: IProps) {
    return (
        <Tooltip title="Help">
            {props.label ?
                <Button href={`/help?page=${props.page}`} target="_blank">{props.label}</Button>
                :
                <IconButton href={`/help?page=${props.page}`} target="_blank" size="small">
                    <LiveHelpIcon color="info" />
                </IconButton>
            }
        </Tooltip>
    );
}